import { Component, OnInit } from '@angular/core';
import {LayoutManagerService} from '../../../layout-manager.service';
import {User} from '../../../User';
import {UserAccessSoftwares} from '../../layouts/full/full.component';
import {ApiService, Software, SoftwaresList, Vps, VpsActivationState} from '../../../api/api.service';
import {ActivatedRoute} from '@angular/router';
import {PaypalApiService} from '../../../api/paypal-api.service';
import {SessionsService} from '../../../sessions.service';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-vps-manager',
  templateUrl: './vps-manager.component.html',
  styleUrls: ['./vps-manager.component.css']
})
export class VpsManagerComponent implements OnInit {

  layoutManager: LayoutManagerService

  changes = true;
  updating = false;
  user: User;
  userAccess: UserAccessSoftwares[];
  private softwareAlreadyTried: { [name: string]: boolean } = {};
  addSoftware: string;
  logOutClicked = false;
  errorStateIdConto = false;
  idContoError: number;
  inizialized = false;
  softwares: SoftwaresList;
  vpsList: Vps[];
  oneLicenceIsActive: boolean;
  vpsChanges = true;
  errorVpsConto = false;
  paypalLoading = false
  trialRequested = false;

  selectedSoftware : Software

  closeModalResult: string;

  vpsActivationState = 'Loading...'
  vpsActivationStateColor = 'label-inverse'

  constructor(
    layoutManagerService: LayoutManagerService,
    private activatedRoute: ActivatedRoute,
    private api: ApiService,
    private paypalApi: PaypalApiService,
    private session:SessionsService,
    private snackBar: MatSnackBar,
    private modalService: NgbModal
  ) {
    this.layoutManager = layoutManagerService
  }

  softwareOptions = undefined

  ngOnInit(): void {
    this.user = this.activatedRoute.snapshot.data.user;
    this.softwares = this.activatedRoute.snapshot.data.softwares;
    this.vpsList = this.activatedRoute.snapshot.data.vps;
    this.userAccess = JSON.parse(atob(this.user.software_access));

    this.oneLicenceActive()

    if (this.vpsList.length>0) {
      this.softwareOptions = this.getSoftwareOptions(this.vpsList[0])

      this.api.getVpsActivationState(this.user.email).subscribe((res) => {
        const activationState = res.state
        if (activationState == 'activating') {
          this.vpsActivationState = "In attivazione"
          this.vpsActivationStateColor = 'label-inverse'
        }
        if (activationState == 'data_ok') {
          this.vpsActivationState = "Dati corretti - Vps attivo"
          this.vpsActivationStateColor = 'label-success'
        }
        if (activationState == 'cred_wrong') {
          this.vpsActivationState = "Credenziali errate"
          this.vpsActivationStateColor = 'label-danger'
        }
        if (activationState == 'maintaining') {
          this.vpsActivationState = "Manutenzione del sistema"
          this.vpsActivationStateColor = 'label-info'
        }
      })
    }
  }

  reloadData() {
    this.updating = true;
    let i = 0;
    this.api.getUser().subscribe(user => {
      this.user = user;
      this.userAccess = JSON.parse(atob(this.user.software_access));
      this.getSoftwaresTried()
      i++;
      this.checkUpdating(i)
    })
    this.api.getVpsInfo().subscribe(vps => {
      this.vpsList = vps;
      i++;
      this.checkUpdating(i)
    })
    this.api.getSoftwaresList().subscribe(soft => {
      this.softwares = soft;
      i++;
      this.checkUpdating(i)
    })
  }

  checkUpdating(i) {
    if (i==3)
      this.updating = false
  }

  openSnackBar(message: string) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 5000;
    this.snackBar.open(message, "Ho capito", config);
  }

  oneLicenceActive() {
    this.userAccess.forEach(res => {
      if (res.activation)
        this.oneLicenceIsActive = true;
    });
  }

  getSoftwaresTried() {
    for (let acc of this.userAccess) {
      this.softwareAlreadyTried[acc.software_name] = true;
    }
    for (let acc of this.userAccess) {
      this.api.checkSoftwareTried(this.user.email, acc.software_name).subscribe(resp => {
        if (resp != undefined) {
          this.softwareAlreadyTried[acc.software_name.toLowerCase()] = resp.result;
        }
      });
    }
  }

  getSoftTri(soft: string) {
    return this.softwareAlreadyTried[soft];
  }

  getSoftwareOptions(currentVps: Vps): any[] {
    const retObj: any[] = [];
    for (let access of this.userAccess) {
      let finded = false;
      let present = false;
      for (let vps of this.vpsList) {
        for (let soft of this.getSoftwaresArray(vps.softwares)) {
          if (soft == access.software_name) {
            finded = (currentVps != vps);
            present = currentVps == vps;
          }
        }
      }
      if (!finded && access.activation)
        retObj.push({
          key: access.software_name,
          value: present
        });
    }
    return retObj;
  }

  getSoftwaresArray(softwares: string): string[] {
    const retObj: string[] = [];
    const val = softwares.split(',');
    for (let v of val) {
      if (v != '')
        retObj.push(v);
    }
    return retObj;
  }

  getFreeSoftwares(): Software[] {
    let softwaresFree = []
    for(let soft of this.softwares.softwares) {
      let used = false;
      for (let acc of this.userAccess) {
        if (soft.software_name.toLowerCase() == acc.software_name)
          used = true
      }
      if (!used) {
        softwaresFree.push(soft)
      }
    }
    return softwaresFree;
  }

  attivaVpsGratuito() {
    this.updating = true;
    this.api.addVpsFreeLicence().subscribe( () => {
      this.api.getVpsInfo().subscribe(response => {
        this.vpsList = response;
        /*for (let soft of this.userAccess) {
          this.addSoftwareToVps(soft.software_name, this.vpsList[0])
        }*/
        this.updating = false;
        //this.reloadData()
        window.location.reload()
      })
    });
  }

  addSoftwareToVps(software: string, vps: Vps) {
    console.log('click')
    let softs : string[] = vps.softwares.split(",")
    let finded = false
    for (let i = 0; i < softs.length; i++)
      if (softs[i] == software)
        finded = true
    if (!finded)
      softs.push(software)
    var softsString = ''
    for (let i = 0; i < softs.length; i++)
      if(softs[i].length>0)
        softsString+=softs[i] + ((i!=softs.length-1) ? ',' : '')
    vps.softwares = softsString
    this.api.updateVps(vps).subscribe( () => {
      window.location.reload()
    });
  }

  basetos(src): string {
    return atob(src)
  }

  removeSoftwareToVps(software: string, vps: Vps) {
    console.log('click')
    let v : string[] = vps.softwares.split(',');
    let v2 : string[] = []
    let reb = '';

    for (let i = 0; i < v.length; i++) {
      if (v[i] != software)
        v2.push(v[i])
    }

    for (let i = 0; i < v2.length; i++) {
      reb+=v2[i] + ((i!=v2.length-1) ? ',' : '')
    }

    vps.softwares = reb;
    this.api.updateVps(vps).subscribe( () => {
      window.location.reload()
    });
  }

  updateIdContoVps(box:HTMLInputElement, vps: Vps) {
    box.value;
    this.api.ceckIdConto(box.value).subscribe(response => {
      if (response.free || atob(response.email).toLowerCase() == this.session.getNameUser().toLowerCase() || box.value == '') {
        vps.id_conto = box.value;
        this.errorVpsConto = false;
        this.vpsChanges = false;
      } else {
        this.openSnackBar("Id conto già usato");
        this.errorVpsConto = true;
      }
    });
  }

  saveVpsChanges() {
    this.vpsList.forEach(vps => {
      // Aggiorno i vps nella lista
      this.updating = true;
      this.api.updateVps(vps).subscribe(res => {
        this.updating = false;
      });
    });
    this.vpsChanges = true;
  }

  isPresent(name: string):boolean {
    for (let vps of this.vpsList) {
      const vp = vps.softwares.split(',');
      for (let v of vp)
        if (v == name)
          return true;
    }
    return false;
  }

}
